/**
 * 404 page controller — /404
 *
 * 唯一職責：把巨數字標題 [data-fuzzy-text] 接上 fuzzy-text.js 特效。
 *
 * 設計（對齊 search.js / articles.js 慣例）：
 *   - root 守門早退：找不到 [data-fuzzy-text] 就 return，非 404 頁不執行、不報錯。
 *     （main.js 在每頁載入，本檔靠守門避免污染其他頁。）
 *   - PRM：fuzzy-text.js 內部偵測 reduce 直接回 null（不初始化）；此時補
 *     .error-page__code--fallback，讓 .visually-hidden 的「404」顯回純文字（最穩 fallback）。
 *   - cleanup 走 pagehide（bfcache 安全），停 rAF + 解事件。
 *
 * vite-plugin-html 每頁只注入單一 entry（/src/main.js）會剝掉頁面手寫的第二支 <script>，
 * 故本控制器由 main.js 中央 import 鏈載入，不靠 404.html 的 inline <script>（同 search.js）。
 */

import { initFuzzyText } from '../components/fuzzy-text.js';

function init() {
  const target = document.querySelector('[data-fuzzy-text]');
  if (!target) return null; // 非 404 頁，早退

  const canvas = target.querySelector('[data-fuzzy-canvas]');
  const text = target.getAttribute('data-fuzzy-text') || target.textContent.trim();

  const handle = canvas ? initFuzzyText(target, { text, mount: canvas }) : null;

  if (!handle) {
    // PRM / 失敗 / 無 canvas：顯回純文字標題（解除 .visually-hidden 隱藏、收掉空 canvas）
    target.classList.add('error-page__code--fallback');
    return null;
  }

  function destroy() {
    handle.destroy();
  }
  window.addEventListener('pagehide', destroy, { once: true });

  return { destroy };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
